import script from "./InfoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoCard.vue?vue&type=script&setup=true&lang=js"

import "./InfoCard.vue?vue&type=style&index=0&id=63dee354&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63dee354"]])

export default __exports__